import { render, staticRenderFns } from "./GroupsAndUsers.vue?vue&type=template&id=64ea1ea3&"
import script from "./GroupsAndUsers.vue?vue&type=script&lang=js&"
export * from "./GroupsAndUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports